import { c as _c } from "react/compiler-runtime";
import { useTranslation } from '@/hooks/use-translation';

/** Reassurance that the work is kept, and kept here. */
export const SavedLocallyIndicator = () => {
  const $ = _c(5);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="size-[7px] rounded-full bg-ptl-ok" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("Saved in this browser");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className="inline-flex items-center gap-[7px] text-[12.5px] text-muted-foreground">{t0}{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};